var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGitlab = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M24 43L16 20 32 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7043",
    d: "M24 43L42 20 32 20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M37 5L42 20 32 20z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M24 43L42 20 45 28z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff7043",
    d: "M24 43L6 20 16 20z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M11 5L6 20 16 20z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa726",
    d: "M24 43L6 20 3 28z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGitlab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gitlab.c54dbd2d930a01103af96f920e9a277f.svg";